import { Component } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (!this.state.hasError) return this.props.children

    const message = this.state.error?.message || 'Something went wrong'

    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
        <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mb-4">
          <AlertTriangle className="w-7 h-7 text-red-500" />
        </div>
        <h2 className="text-lg font-bold text-gray-900 mb-1">Page Error</h2>
        <p className="text-sm text-gray-500 mb-2 max-w-sm">{message}</p>
        {import.meta.env.DEV && (
          <pre className="text-xs text-red-400 bg-red-50 rounded-lg p-3 mb-4 max-w-lg text-left overflow-auto max-h-40">
            {this.state.error?.stack}
          </pre>
        )}
        <button
          onClick={this.handleReset}
          className="btn-secondary flex items-center gap-2"
        >
          <RefreshCw className="w-4 h-4" /> Try again
        </button>
      </div>
    )
  }
}
